/**
 * useTrackClick — generic click tracker for all platform surfaces.
 *
 * Takes the same three parameters as useTrackImpression but differs in shape:
 * useTrackImpression returns void and fires on mount via useEffect, while
 * useTrackClick returns a callback that the caller invokes imperatively from
 * a click handler. Don't substitute one for the other.
 *
 * Usage:
 *   const trackClick = useTrackClick(EntityType.hub, hub._id, TrackSurface.hub_page);
 *   <button onClick={() => { trackClick(); navigate(...); }} />
 */

import {useCallback} from "react";
import {EntityType, TrackEvent, TrackSurface} from "@devour/client";
import analytics from "@/utils/analytics";

export function useTrackClick(
    entityType: EntityType,
    entityId: string | undefined,
    surface: TrackSurface,
): () => void {
    return useCallback(() => {
        if (entityId) {
            void analytics.track({entityType, entityId, event: TrackEvent.click, surface});
        }
    }, [entityType, entityId, surface]);
}
